import { GETALL_REQUEST, GETALL_FAILURE, GETALL_SUCCESS, GET_USERS_LIST, REDIRECT_TO_HOME, RESET_PASSWORD_FAIL } from "../types"

const initialState = {
	list: [],
	isLoading: false,
	redirectToHome: false,
	resetPasswordError: null,
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case GETALL_REQUEST:
			return {
				loading: true,
			}
		case GETALL_SUCCESS:
			return {
				items: action.payload,
			}
		case GETALL_FAILURE:
			return {
				error: action.payload,
			}
		case GET_USERS_LIST:
			return {
				currentUsersList: action.payload,
			}
		case REDIRECT_TO_HOME:
			return {
				...state,
				redirectToHome: action.payload,
			}
		case RESET_PASSWORD_FAIL: {
			return {
				...state,
				resetPasswordError: action.payload,
			}
		}
		default:
			return state
	}
}
